import type {RuleType, SchemaValidationValue} from '../types'
export const required = (Rule: RuleType): SchemaValidationValue => Rule.required()
